module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allEmphasize":"All emphasize","allDeselect":"All deselect","init":"Return to the initial state"},"ja":{"allEmphasize":"すべて強調","allDeselect":"すべて解除","init":"初期状態に戻す"},"zh-hant":{"allEmphasize":"全部強調","allDeselect":"全不選","init":"返回初始狀態"},"zh-hans":{"allEmphasize":"全强调","allDeselect":"取消选择","init":"返回初始状态"}}')
  delete Component.options._Ctor
}
